import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TerritoryCountService {
  territoriesCount = new Subject<object>();

  constructor() {}
}
